// Replaces <br> tags with empty paragraphs to reduce excessive spacing
// between successive paragraphs and adjacent lists in message content.
// Defined as a named component so the table renderers can filter
// it out the same way they filter native <br> elements.
export const CustomBrRenderer = () => <p className="!my-2" />;
